import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import ContactSupport from "./ContactSupport";

/**
 * Sticky banner shown for the read-only investor demo viewer role.
 * Rendered inside Layout above the header.
 */
export default function DemoBanner() {
  const { isViewer, logout } = useAuth();
  const { t } = useTranslation();
  if (!isViewer) return null;

  return (
    <div
      data-testid="demo-banner"
      className="w-full bg-ink text-bg border-b border-leaf/30"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-9 flex items-center justify-between gap-4 text-[11px] font-mono uppercase tracking-[0.18em]">
        <div className="flex items-center gap-3">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-leaf animate-pulse"></span>
          <span className="text-leaf">{t("demo.eyebrow")}</span>
          <span className="hidden sm:inline text-bg/70 normal-case tracking-normal font-sans text-xs">
            {t("demo.note")}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/marketplace" className="hover:underline" data-testid="demo-marketplace">{t("demo.marketplace")}</Link>
          <Link to="/portfolio" className="hover:underline" data-testid="demo-portfolio">{t("demo.portfolio")}</Link>
          <Link to="/registry" className="hover:underline hidden md:inline" data-testid="demo-registry">{t("demo.registry")}</Link>
          <ContactSupport variant="inline" className="text-bg/70 hover:text-bg" subject="GreenBelt — investor demo question" />
          <button onClick={logout} data-testid="demo-exit" className="text-bg/70 hover:text-bg underline underline-offset-4">
            {t("demo.exit")}
          </button>
        </div>
      </div>
    </div>
  );
}
